import { ProcessObject } from '@/routes/process-objects/list/types';
import { PaginatedResponse } from '@/utils/types';
import { TaskType } from '../types';

export type CalibrationTaskListResponse = PaginatedResponse<Task>;

export type Task = {
	id: string;
	measurementGroupId: number;
	measurementGroupName: string;
	type: TaskType;
	requestTime: string;
	metadata: MetadataDetails;
	taskStartTime: string;
	taskEndTime: string;
	dataStartTime: string;
	dataEndTime: string;
	fileReferenceData: string;
	fileHistoricalData: string;
	fileInitialCalibration: string;
	fileUpdatedCalibration: string;
	results: Results;
	status: CalibrationsTaskStatus;
	statusLastUpdateTime: string;
	filesDeletedAt: string;
	fileRevisionData: string;
};

export enum CalibrationsTaskStatus {
	REQUESTED = 'REQUESTED',
	REQUEST_FAILED = 'REQUEST_FAILED',
	REQUEST_CANCELED = 'REQUEST_CANCELED',
	PENDING = 'PENDING',
	STARTED = 'STARTED',
	SUCCESS = 'SUCCESS',
	CANCELED = 'CANCELED',
	DESYNCHRONIZED = 'DESYNCHRONIZED',
	FAILURE = 'FAILURE'
}

export type MetadataDetails = {
	measurementGroupId: number;
	startTime: string;
	endTime: string;
	intercept: boolean;
	onlyHistoricalData: boolean;
	processObjects: ProcessObject[];
};

export type Results = {
	timeAdj: number;
	cx: number;
	cy: number;
	primaryCalFactor: number;
	sag: number;
	lineVoltage: number;
};

export type QueryCalibrationTasksListArgs = {
	limit: string;
	page: string;
	sortBy: string;
	sortDirection: string;
	mgId: string;
	type: string;
	status: string;
};

export enum CalibrationTasksSortableColumns {
	measurementGroupId = 'MEASUREMENT_GROUP_ID',
	status = 'STATUS',
	submissionDate = 'SUBMISSION_DATE',
	type = 'TYPE'
}
